<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <b-tabs v-model="tab">
                        <b-tab :title="$t('library.content_license')">
                            <data-table :edit-item="editItem" />
                        </b-tab>
                        <b-tab :title="$t('site.add')">
                            <my-form :new-item="newItem" />
                        </b-tab>
                    </b-tabs>
                </div>
                <!-- end of card body -->
            </div>
            <!-- end of card -->
        </div>
        <!-- end of col -->
    </div>
</template>

<script>
    import DataTableVue from "./components/DataTable.vue";
    import FormVue from "./components/Form.vue";

    export default {
        name: "LicensesIndex",
        components: {
            "data-table": DataTableVue,
            "my-form": FormVue,

        },
        data() {
            return {
                newItem: {},
                tab: 0,
            };
        },
        methods: {
            editItem(data) {
                this.newItem = data.item;
                this.tab = 1;
            },
        },
    };
</script>
